import { RefQuantiteFacture } from './ref-quantite-facture.model';

export class QuantiteInfos {
    quantite?: number;
    refQuantiteFacture?: RefQuantiteFacture;
    libelle?: string;

    constructor(quantite?: number, refQuantiteFacture?: RefQuantiteFacture, libelle?: string) {
        this.quantite = quantite;
        this.refQuantiteFacture = refQuantiteFacture;
        this.libelle = libelle;
    }
}
